export function getNumber(value: any): number {
  return Number(
    (value || 0)
      .toString()
      .replace(/\s+/g, '')
      .replace(/,/g, '.')
  );
}

export function safeNumber(value: any, defaultValue = 0) {
  // Check for NaN, null, undefined, or non-numeric values
  if (value === null || value === undefined || Number.isNaN(Number(value)) || value === '' || value === 'NaN') {
    return defaultValue;
  }
  // Convert to number and return
  return Number(value);
}
